import { getApiUrl } from "../utils/get-api-url";

export const getTerms = async data => {
  const params = new URLSearchParams(data);
  const apiUrl = getApiUrl("ixvocab");
  const fullUrl = `${apiUrl}/contexts/OFCCPoliciesView/terms?${params.toString()}`;
  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include"
  });

  const { statusText, ok, status } = response;
  if (!ok) throw new Error({ statusText, status });

  const json = await response.json();
  return Promise.resolve(json);
};
